export enum CreateAccountView {
  // Manual Pitch with no offers available ("You are nearly there!").
  ManualNoOffers = 'ManualNoOffers',
  // Manual Pitch with available offers OR Auto Pitch with an expired / rejected result
  // (congratulations banner with the max loan amount and the lowest APR).
  OffersAvailable = 'OffersAvailable',
  // Auto Pitch with an accepted offer (plain form, no banner / intro).
  OfferAccepted = 'OfferAccepted',
}
